import React from 'react'
export default <path d="M15 20H25M20 15V25" stroke="#141414"/>
